/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum responseFormatEnum {
    QUESTION = 'question',
    EXPERT = 'expert',
}